import gql from "graphql-tag";

export const ENABLE_TOKEN = gql`
  mutation EnableToken($where: TokenWhereInput, $data: TokenDataInput) {
    enableToken(where: $where, data: $data) {
      id
    }
  }
`;

const limitItem = { ENABLE_TOKEN };

export default limitItem;
